import React, { Component } from 'react'
import { DynamicForm } from './DynamicForm'
import { ApiHelper } from '../helpers/ApiHelper'
import { Helper } from '../helpers/Helper'
import {
  buildAddModalWaTemplateFromForm,
  emptyWaBodyRichText,
  hooksBridgeErrorMessage,
  waTemplateToActualWaTemplate,
} from '../../screens/admin/cdp/WhatsappTemplateDetail'
import { withVendorProjectIdQueryParam } from '../../screens/admin/cdp/WhatsappUtils'

const NONE = 'NONE'
const MAX_BUTTON_ROWS = 3

function buttonRowsToLegacyFormFields(rows) {
  const list = (rows || []).slice(0, MAX_BUTTON_ROWS)
  const out = {}

  for (let slot = 1; slot <= MAX_BUTTON_ROWS; slot++) {
    const r = list[slot - 1]

    out[`button${slot}Type`] = r && r.type ? r.type : NONE
    out[`button${slot}Text`] = r ? String(r.text || '') : ''
    out[`button${slot}Url`] = r && r.type === 'URL' ? String(r.url || '') : ''
    out[`button${slot}Phone`] = r && r.type === 'PHONE' ? String(r.phone || '') : ''
    out[`button${slot}UrlVariable`] = r && r.type === 'URL' ? String(r.urlVariable || '') : ''
    out[`button${slot}FlowId`] = r && r.type === 'FLOW' ? String(r.flowId || '') : ''
  }

  return out
}
const buildBulkCopyFormFieldDef = (availableWabas) => ({
    title: 'Bulk Copy Template',
    ctaButtonText: 'Submit',
    formType: 'edit',  
    steps: [
      {
        fields: [
          {
            key: 'selectedWabas',
            type: 'check_box',
            label: 'Select WABA numbers (max 10)',
            tip: 'Choose one or more WhatsApp Business Account numbers to copy the template to',
            options: availableWabas.map(waba => ({
              key: waba.key,
              label: waba.label || waba.key
            })),
            v_required: {
              value: true,
              err: 'Select at least one WABA number'
            },
            placement: 'left',  
            defaultValue: [],  
          }
        ]
      }
    ]
})

class BulkCopyTemplateForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formDefinition: null,
    }
  }

  componentDidMount() {
    const { availableWabas } = this.props
    const formDefinition = buildBulkCopyFormFieldDef(availableWabas || [])
    this.setState({ formDefinition })
  }

  handleFormSubmit = async ({ formData }, done) => {
    const selectedWabas = formData.selectedWabas || []
    const selectedWabaKeys = Array.isArray(selectedWabas)
      ? selectedWabas.map(waba => typeof waba === 'string' ? waba : waba.key)
      : []

    if (selectedWabaKeys.length === 0) {
      if (done) done()
      return
    }
    if (selectedWabaKeys.length > 10) {
      this.showMessage('You can copy to a maximum of 10 WABA numbers at a time', undefined, 'Error')
      if (done) done()
      return
    }
    const { ms, orgId, copyTemplateInitialForm, selectedTemplate, crmNumbers } = this.props
    const copyPromises = selectedWabaKeys.map(async (targetWabaNumber) => {
      try {
        const { buttonRows, ...formRest } = copyTemplateInitialForm
        const bodyTextVariableExamples = Object.entries(formRest.bodyVariableExamplesByToken || {})
        .map(([token, value]) => {
          const idx = parseInt(token.replace(/[{}]/g, ''), 10)
          return { idx, value: String(value).trim() }
        })
        .sort((a, b) => a.idx - b.idx)
        .map(item => item.value)
        .join('|')
        const templateFormData = {
          ...formRest,
          bodyTextVariableExamples,
          ...buttonRowsToLegacyFormFields(buttonRows),
          wabaNumber: targetWabaNumber,
          title: selectedTemplate.name || formRest.title,
          bodyRichText: copyTemplateInitialForm.bodyRichText || emptyWaBodyRichText(),
        }
        const waTemplate = buildAddModalWaTemplateFromForm(templateFormData)
        const actualWaTemplate = waTemplateToActualWaTemplate(waTemplate)
        const data = await ApiHelper.callAwait({
          ms,
          method: 'POST',
          paths: ['hooks'],
          queryParams: withVendorProjectIdQueryParam({
            orgId,
            bridgePath: 'whatsapptemplates',
          }, targetWabaNumber, crmNumbers),
          jsonBody: {
            fromNumber: targetWabaNumber,
            template: actualWaTemplate,
          },
        })
        const bridgeErr = hooksBridgeErrorMessage(data)
        if (bridgeErr) {
          return { success: false, wabaNumber: targetWabaNumber, error: bridgeErr }
        }
        if (data && data.status === 'REJECTED') {
          const rejectReason = data.rejected_reason || 'Template was rejected'
          return { success: false, wabaNumber: targetWabaNumber, error: rejectReason }
        }
        return { success: true, wabaNumber: targetWabaNumber }
      } catch (err) {
        console.error(`Error copying template to ${targetWabaNumber}:`, err)
        return { success: false, wabaNumber: targetWabaNumber, error: err.message }
      }
    })
    const results = await Promise.all(copyPromises)
    const successCount = results.filter(r => r.success).length
    const failedNumbers = results.filter(r => !r.success).map(r => r.wabaNumber)
    if (this.props.onSubmit) {
      this.props.onSubmit({
        successCount,
        failedNumbers,
        selectedWabaKeys,
      })
    }
    if (done) done()
  }

  render() {
    const { formDefinition } = this.state
    const { selectedTemplate, inProgress } = this.props

    if (!formDefinition || !selectedTemplate) {
      return null
    }

    return (
      <div style={{ padding: '15px', paddingBottom: '5px' }}>
        <DynamicForm
          formDefinition={formDefinition}
          customSubmit={this.handleFormSubmit}
          disabled={inProgress}
        />
      </div>
    )
  }
}

export default BulkCopyTemplateForm